const sameId = (a, b) => String(a) === String(b);

const sortedIds = (items) => (Array.isArray(items) ? items.map((item) => String(item?.id)).sort() : []);

const sameIdList = (a, b) => {
    const idsA = sortedIds(a);
    const idsB = sortedIds(b);
    return idsA.length === idsB.length && idsA.every((id, index) => id === idsB[index]);
};

export function sameCartItem(item, product) {
    if (!item || !product || !sameId(item.id, product.id)) return false;

    if (item.custom_fast_set || product.custom_fast_set) {
        return item.custom_fast_set === product.custom_fast_set && sameIdList(item.products, product.products);
    }

    if (item.fast_set || product.fast_set) {
        const modifierId = (value) => String(value?.id ?? value ?? "");
        return item.fast_set === product.fast_set && modifierId(item.modifier) === modifierId(product.modifier);
    }

    const activeMods = (groups) => (Array.isArray(groups) ? groups : [])
        .map((group) => ({
            id: String(group?.id),
            items: sortedIds(group?.items),
        }))
        .filter((group) => group.items.length)
        .sort((a, b) => a.id.localeCompare(b.id));

    const modsA = activeMods(item.mods);
    const modsB = activeMods(product.mods);
    if (modsA.length !== modsB.length) return false;
    if (!modsA.every((group, index) =>
        group.id === modsB[index].id &&
        group.items.length === modsB[index].items.length &&
        group.items.every((id, itemIndex) => id === modsB[index].items[itemIndex])
    )) return false;

    return sameIdList(item.active_condiments, product.active_condiments);
}

export function withRequiredMods(product) {
    if (!product || typeof product !== "object") return null;

    const groups = Array.isArray(product.group_mods) ? product.group_mods : [];
    const mods = Array.isArray(product.mods)
        ? product.mods.map(group => ({ ...group, items: Array.isArray(group.items) ? [...group.items] : [] }))
        : [];

    for (const group of groups) {
        const min = Number(group?.restrictions?.minQuantity) || 0;
        if (min < 1) continue;

        const selection = mods.find(mod => sameId(mod.id, group.id));
        const selected = selection?.items?.filter(item => group.items?.some(option => sameId(option.id, item.id))) || [];
        if (selected.length >= min) continue;

        const available = (Array.isArray(group.items) ? group.items : [])
            .filter(option => !selected.some(item => sameId(item.id, option.id)))
            .slice(0, min - selected.length)
            .map(option => ({ id: option.id, name: option.name }));
        if (selected.length + available.length < min) return null;

        if (selection) selection.items = [...selected, ...available];
        else mods.push({ id: group.id, items: available });
    }

    return { ...product, mods, with_group_mods: mods.some(group => group.items.length > 0) };
}
